<template>
    <div class="flexContainer full ai-c jc-sb" :class="{ menuHeaderWhenSave: hasUpdatePlano === true, menuHeaderPlano: hasUpdatePlano === false }">
        <div class="flexContainer ai-c size4of12 m-w-one-quart">
            <div class="size3of12">
                <button
                    id="cancelPlano"
                    class="cancel pointer"
                    v-if="showButton === true && lock === 'false' && hasAccessUpdate('plano_builder')"
                    @click="cancel('cancel');"
                >
                    <img class="return" src="../../../../static/img/returnBtn.png" alt="" />
                    <span class="tabletNot mobileNot">{{ $t("headerPlano.cancel") }}</span>
                </button>

                <button id="return" class="cancel pointer" v-if="lock === 'true' || !hasAccessUpdate('plano_builder')" @click="cancel('retour');">
                    <img class="return" src="../../../../static/img/returnBtn.png" alt="" />
                    <span class="tabletNot mobileNot">{{ $t("headerPlano.back") }}</span>
                </button>

                <button id="saveModule" v-if="!showButton" @click="closeModule(false);" class="pointer cancel pointer size4of12">
                    <img class="return" src="../../../../static/img/returnBtn.png" alt="" />
                    <span class="tabletNot mobileNot">{{ $t("planobuilder.cancelShades") }}</span>
                </button>
            </div>
            <div class="titleBy ff-light size8of12">
                <div data="title-by--info-data" class="flexContainer ">
                    <div class="full">
                        <p>{{ $t("planobuilder.by") }} {{ userCreated.firstname ? userCreated.firstname : "" }} {{ userCreated.lastname }}</p>
                        <p>
                            {{ $t("planobuilder.modifiedBy") }} {{ modifiedUser.firstname }} {{ modifiedUser.lastname }} {{ $t("planobuilder.on") }}
                            {{ modifiedUser.date }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="planoInfo flexContainer ai-c fd-c m-w-three-quart m-ai-fs" :class="{ moduleMode: showButton === false }">
            <p class="title ff-medium uppercase m-txtLeft">{{ planoDetails.name }}</p>
            <p class="campaignName uppercase m-txtLeft">
                {{ planoDetails.campaign ? planoDetails.campaign.name : "" }} - {{ planoDetails.zone ? planoDetails.zone.name : "" }}
            </p>
        </div>

        <div class="flexContainer jc-fe show-only-min-768">
            <button data="title-by--info" class="save pointer" @click="toggleDisplayInfo($event);">
                <img class="" src="../../../../static/img/info.png" alt="" height="16" />
            </button>
        </div>
        <div id="savePlano" class="mobileNot flexContainer jc-fe size4of12">
            <button id="cancelModule" v-if="!showButton" @click="closeModule(true);" class="save uppercase pointer">
                {{ $t("planobuilder.saveShades") }}
            </button>

            <!-- <button -->
            <button
                v-if="
                    getShowRestore === false &&
                        showButton === true &&
                        this.lock === 'false' &&
                        hasAccessUpdate('plano_builder') &&
                        !getPlanoDetails.archived &&
                        getPlanoDetails.status === 'IN PROGRESS'
                "
                class="save pointer"
                id="saveOnly"
                @click="savePlano('save');"
            >
                <img class="return" src="../../../../static/img/save.png" alt="" height="16" />
                <span class="tabletNot mobileNot">{{ $t("headerPlano.save") }}</span>
            </button>
            <!-- RESTORE BTN -->
            <button
                v-if="
                    getShowRestore === true &&
                        hasAccessUpdate('plano_builder') &&
                        !getPlanoDetails.archived &&
                        getPlanoDetails.status === 'IN PROGRESS'
                "
                class="save pointer"
                id="restore"
                @click="restore();"
            >
                <img class="return" src="../../../../static/img/save.png" alt="" height="16" /> <span class="tabletNot mobileNot">RESTORE</span>
            </button>

            <!-- <button -->
            <button
                v-if="
                    getShowRestore === false &&
                        showButton === true &&
                        this.lock === 'false' &&
                        hasAccessUpdate('plano_builder') &&
                        !getPlanoDetails.archived &&
                        getPlanoDetails.status === 'IN PROGRESS'
                "
                class="saveExit pointer"
                id="saveExit"
                @click="savePlano('saveExit');"
            >
                {{ $t("headerPlano.saveExit") }}
            </button>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import httpService from "../../service";
import { stateMixin } from "./../mixins/state";
import { i18n, bus } from "../../../main";
import SelectorLang from "../../../components/langSelector/langSelector.vue";
import Globals from "../../globals";
import cacheService from "@/services/cache";

// import storeUtils from "../../../store/storeUtils"
//    import { i18n } from '../../../main'

export default {
    mixins: [stateMixin],
    data: () => ({
        showButton: true,
        planoId: "",
        planoDetails: {},
        userCreated: {},
        lock: "",
        modifiedUser: {},
        selectedCampaign: cacheService.getCurrentCampaignId(),
        access: "",
        allows: "",
        showRestore: false
    }),
    components: {
        selectorLang: SelectorLang
    },
    computed: {
        ...mapGetters({
            getPlanoDetails: "plano/data/getPlanoDetails",
            getMeuble: "plano/data/getMeuble",
            getGroups: "plano/status/getGroups",
            getRestorePlano: "plano/data/getRestorePlano",
            getRestorePlanoId: "plano/data/getRestorePlanoId",
            getShowRestore: "plano/data/getShowRestore"
        }),
        retMode() {
            return this.$store.state.plano.status.builder.mode;
        },
        retModifiedDate() {
            return this.$store.state.plano.status.builder.modifiedUser;
        }
    },
    watch: {
        retMode: function(val) {
            if (val === "module") {
                this.showButton = false;
            } else {
                this.showButton = true;
            }
        },
        retModifiedDate: function(val) {
            this.modifiedUser = val;
        }
    },
    methods: {
        ...mapActions({
            setShowRestore: "plano/data/setShowRestore"
        }),
        restore() {
            let version = {
                version: this.getRestorePlanoId
            };
            httpService.post("/plano/" + this.$route.params.id + "/restore", JSON.stringify(version)).then(response => {
                this.setShowRestore(false);
                cacheService.set("showRestore", false);
            });
        },
        isNotSafari() {
            return Globals.getNavigator() !== Globals.NAVIGATOR_SAFARI;
        },
        toggleDisplayInfo: function(evt) {
            evt.preventDefault();
            let wrapperMenu = this.$el;
            let btn = this.$el.querySelector('[data="title-by--info"]');
            let hasAttributeDisplayed = btn.hasAttribute("data-info-displayed");
            let dataInfo = wrapperMenu.querySelector('[data="title-by--info-data"]');

            if (hasAttributeDisplayed) {
                btn.removeAttribute("data-info-displayed");
                dataInfo.removeAttribute("style");
                dataInfo.removeAttribute("data-position");
            } else {
                btn.setAttribute("data-info-displayed", "");
                dataInfo.setAttribute("data-position", "absolute");
                dataInfo.setAttribute("style", "display:flex;");
            }
        },
        savePlano(mode) {
            this.$parent.trust = true;
            bus.$emit("plano_save", mode);
        },
        cancel(a) {
            this.$parent.trust = true;
            let self = this;
            if (a === "retour") {
                self.$router.replace("/planos");
            } else if (a === "cancel") {
                let confirmTitle;
                let warningText;
                let confirmDelete;
                if (i18n.locale === "fr") {
                    confirmTitle = "Sortir du planogramme ?";
                    warningText = "Etes-vous de vouloir quitter ? Vos changements ne seront pas pris en compte!";
                    confirmDelete = "Oui, quitter!";
                } else if (i18n.locale === "en") {
                    confirmTitle = "Close this planogramme ?";
                    warningText = "Are you sure? You won't be able to revert the changes!";
                    confirmDelete = "Yes, close it!";
                }
                this.$swal({
                    title: confirmTitle,
                    text: warningText,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#41b4e8",
                    confirmButtonText: confirmDelete,
                    closeOnConfirm: true
                }).then(result => {
                    if (result === true) {
                        httpService.post("/plano/" + this.$route.params.id + "/back").then(response => {
                            self.$store.state.plano.status.builder.groups = [];
                            cacheService.set("showRestore", false);
                            self.setShowRestore(false);
                            self.$router.push({
                                name: "Planos",
                                query: self.getLinkParams({ campaign: self.selectedCampaign })
                            });
                        });
                    } else {
                    }
                });
            }
        },
        closeModule(save) {
            this.setMode("plano");
            this.setModeSave(save);
        },
        getLinkParams(x) {
            const temp = {};
            for (let key in this.$route.query) {
                if (x[key] !== null) {
                    temp[key] = this.$route.query[key];
                }
            }

            for (let key in x) {
                if (x[key] !== null) {
                    temp[key] = x[key];
                }
            }
            return temp;
        }
    },
    mounted() {},
    created() {
        this.planoDetails = this.getPlanoDetails;
        this.userCreated = this.getPlanoDetails.createdUser;
        let user = cacheService.getRem3rchUser();
        if (
            user.user.firstname === this.getPlanoDetails.modifiedUser.firstname &&
            user.user.lastname === this.getPlanoDetails.modifiedUser.lastname
        ) {
            this.access = true;
        } else {
            this.access = false;
        }
        cacheService.set("planoAccess", this.access);
        this.modifiedUser = {
            firstname: this.getPlanoDetails.modifiedUser.firstname,
            lastname: this.getPlanoDetails.modifiedUser.lastname,
            date: this.getPlanoDetails.modifiedUser.modifiedDate
        };

        this.lock = cacheService.get("planoLocked");
        this.allows = cacheService.get("planoAccess");
        this.showRestore = cacheService.get("showRestore");
    }
};
</script>
<style scoped lang="scss">
[data="title-by--info-data"][data-position="absolute"] {
    position: absolute;
    top: 62px;
    left: 0;
    width: 100%;
    z-index: 30;
    background: #000;
    padding: 1rem;
}

[data="title-by--info-data"] a {
    cursor: pointer;
    // min-width: 24px;
    display: inline-block;
    text-align: center;
}

.moduleMode {
    margin: 0 auto;
}

.campaignName {
    font-family: "Oswald", Sans-Serif;
    font-size: 16px;
}

.menuHeaderWhenSave {
    background-color: #8ab200;
    color: white;
    padding: 0 1rem;

    .txtCenter {
        line-height: 1px;
        color: white;
        font-family: Roboto;
    }
}

.menuHeaderPlano {
    height: 63px;
    background-color: black;
    color: white;

    .txtCenter {
        line-height: 1px;
        color: white;
        font-family: Roboto;
    }
}

.cancel,
.save,
.saveExit {
    color: white;
    border: 1px solid white;
    padding: 1rem;
    margin: 1rem;
    min-width: 30px;
    background-color: transparent;
    border-radius: 2rem;
}

.return {
    padding-bottom: 3px;
}

#cancelModule,
#saveModule {
    color: #fff;
    border: 1px solid #fff;
}

.titleBy {
    font-family: Roboto;
    font-size: 11px;
    padding: 0.5rem;

    & > p {
        margin: 0.5rem;
    }
}

.title {
    font-family: "Oswald", Sans-Serif;
    font-size: 25px;
    line-height: 30px;
    margin: 0;
}

@media only screen and (max-width: 768px) {
    .title {
        font-family: "Oswald", Sans-Serif;
        font-size: 20px;
        line-height: 30px;
        margin: 0;
    }

    .show-only-min-768 {
        display: block;
    }
}

@media only screen and (max-width: 767px) {
    [data="title-by--info-data"] {
        display: none;
    }
    #menuHeaderPlano {
        #cancelPlano {
            .return {
                padding: 0;
            }
        }
    }
    .planoInfo {
        p {
            margin: 0;
        }
    }
}

@media only screen and (min-width: 768px) {
    .show-only-min-768 {
        display: none;
    }
    button {
        font-size: 1.2rem;
    }
    .cancel {
        img {
            padding: 0;
        }
    }

    .planoInfo {
        p {
            margin: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// HeaderPlano.vue?0ee22618